module.exports = __webpack_public_path__ + "img/register_03.15c404ea.png";